import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IPostResetPasswordResponseApi } from "@interfaces/IPostResetPasswordResponseApi.ts"
import { IPostResetPasswordResponseCli } from "@interfaces/IPostResetPasswordResponseCli.ts"

export const PostResetPasswordAdapter = (
	response: IApiResponse<IPostResetPasswordResponseApi>
): IPostResetPasswordResponseCli => response?.data
